import React from "react";
import { Modal } from "react-bootstrap";

interface StatusModalProps {
  onSuccess?: () => void;
  onClose: () => void;
  shouldShow: boolean;
  message: string;
  type: number;
}

export default function StatusModal({ onSuccess, onClose, shouldShow, message, type }: StatusModalProps) {
  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body bsPrefix={"main-container"}>
          <div className="modal-body">
            <h4 className="rider-name-content">{message}</h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button type="button" className="rkmd-btn btn-lg btn-black ripple-effect w-100 mt-3" onClick={onClose}>
              {type == 2 ? "Stay" : "Close"}
            </button>
          </div>
          {type == 2 && (
            <div className="btn-wrap mb-3">
              <button type="button" className="rkmd-btn btn-lg btn-red ripple-effect w-100 mt-3" onClick={onSuccess}>
                Leave
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
